import React, { useState, useEffect } from 'react'
import AdminNav from './AdminNav'
import AdminHeader from './AdminHeader'
import axios from 'axios'
import env from '../../enviroinment'
import LoadingSpinner from '../loadingSpinner'
const PaymentDetails = () => {
  const [loading,setLoading]=useState(false);
  const [data, setData] = useState([])
  let token = sessionStorage.getItem('token')
  let userId = sessionStorage.getItem('userId')
  let loadData = async () => {
    try{
      setLoading(true);
      let res = await axios.get(`${env.apiurl}/admin/getpaymentqr`, {
        headers: { Authorization: `Bearer ${token}`, adminid: userId },
      })
      setLoading(false);
      if (res.data.statusCode === 200) {
        let arr = []
        const { paymentUpi, upiMobile, upiName, businessQr } = res.data
        let object = {
          paymentUpi: paymentUpi,
          upiMobile: upiMobile,
          businessQr: businessQr,
          upiName: upiName,
        }
        arr.push(object)
        setData(arr)
      } else {
      }
    }catch(error){
      setLoading(false);
    }
   
  }
  useEffect(() => {
    loadData()
  }, [])
  useEffect(() => {
    loadData()
  }, [])
  return (
    <>
    {loading ? <LoadingSpinner /> : null}
    <div>
      <div className="Main_header">
        <AdminHeader />
        <AdminNav />
      </div>
      <div className="container">
        <div className="frameTitle">
          <h2 className="heading20_bold">Payment Details</h2>
        </div>
        <div className="ViewPage_frame">
          {data?.map((payment, index) => (
            <div key={index} className="row">
              <div className="col-md-2 mobSpace_mb24">
                <h5 className="inputTitle mb_12 textAlign_center">
                  UPI QR Code
                </h5>
                <div className="qrCodeImageFrame">
                  <img
                    src={payment.businessQr ? payment.businessQr : null}
                    alt=""
                    width={'200px'}
                    height={'200px'}
                  />
                </div>
              </div>
              <div className="col-md-9">
                <table className="viewDetail_table tableResponsive mt_34">
                  <tr>
                    <th>UPI Name</th>
                    <td>{payment.upiName}</td>
                  </tr>
                  <tr>
                    <th>UPI ID</th>
                    <td>{payment.paymentUpi}</td>
                  </tr>
                  <th>UPI Phone No</th>
                  <td>{payment.upiMobile}</td>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  )
}

export default PaymentDetails
